module.exports = __webpack_public_path__ + "static/unlock-efbc15ef159d5322584181216e462e0a.svg";